import React from 'react';

const EmptyPayload = (props) => (
  <div className="d-flex justify-content-center centered-message">
    <h1 className="white align-self-center block text-center">{props.message}</h1>
  </div>
)

export default EmptyPayload;